import React from "react";

import AppProviders from "./app/AppProviders";
import AppRoutes from "./routes/AppRoutes";

/**
 * App root. Composes provider stack + route tree. Per
 * RW-react-core-standards `frontend-architecture.md` §9, this file is kept
 * intentionally thin: providers live in `app/AppProviders`, the route tree
 * lives in `routes/AppRoutes`. Adding a new provider or page should not
 * touch this file.
 */
const App: React.FC = () => {
  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
};

export default App;
